import React, { FormEvent } from 'react';
import { Content, Form, Header, Title } from './styles';
import ModalResponsive from '@app/components/ModalResponsive';
import FormInput from './FormInput';
import Image from 'next/image';
import { SuccessButton } from '@app/styles/components';
import { APIDivulgador } from '@app/services/divulgador-api';
import { useRestaurantContext } from '../context';
import { useClientArea } from '@app/contexts/ClientArea';
import { useState } from 'react';
import { ErrorMessage } from '@app/styles/forms';
import { IconButton } from '@material-ui/core';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';
import { NotAccountOwnerError } from '@app/contexts/ClientArea/errors';

export type LoginModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

export default function LoginModal({ isVisible, onClose }: LoginModalProps) {
  const { cliqueiAcheiData } = useRestaurantContext();
  const clientArea = useClientArea();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [passwordIsVisible, setPasswordIsVisible] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setErrorMessage(null);
    const formData = new FormData(event.currentTarget);
    try {
      const { data: token } = await APIDivulgador.logIn({
        password: String(formData.get('password') ?? ''),
        username: String(formData.get('email') ?? ''),
      });
      await clientArea.fetchBusiness(token, cliqueiAcheiData.Cod_Cliente);
      onClose();
      window.scrollTo({ top: 0 });
    } catch (error) {
      handleLoginError(error);
    }

    function handleLoginError(error: any) {
      if (error instanceof NotAccountOwnerError) {
        setErrorMessage('Você não tem permissão para acessar esse cardápio');
      } else if (error?.response?.status === 401) {
        setErrorMessage('Algo deu errado! Verifique se você inseriu seu e-mail e senha do Cliquei Achei corretamente.');
      } else if (!error.response) {
        setErrorMessage('Ocorreu um erro. Verifique sua conexão com a internet.');
      } else {
        setErrorMessage('Ocorreu um erro. Tente novamente mais tarde.');
      }
    }
  }

  return (
    <ModalResponsive
      open={isVisible}
      onClose={onClose}
      appBarConfig={{ title: 'Login' }}
      desktopWidthContent={435}
      desktopHeightContent="fit-content"
    >
      <Content>
        <Header>
          <Image src="/static/login-lock.svg" layout="intrinsic" width={78} height={78} />
          <Title>Ponto de Venda</Title>
        </Header>
        <Form onSubmit={handleSubmit} name="restaurant-login-form">
          <FormInput label="E-mail" name="email" placeholder="voce@email.com" />
          <FormInput
            type={passwordIsVisible ? 'text' : 'password'}
            label="Senha"
            name="password"
            placeholder="********"
            right={
              <PasswordVisibility
                isVisible={passwordIsVisible}
                onClick={() => setPasswordIsVisible(!passwordIsVisible)}
              />
            }
          />
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          <SuccessButton type="submit">
            <span>ENTRAR</span>
          </SuccessButton>
        </Form>
      </Content>
    </ModalResponsive>
  );
}

type PasswordVisibilityProps = {
  isVisible: boolean;
  onClick: () => void;
};

function PasswordVisibility({ isVisible, onClick }: PasswordVisibilityProps) {
  return (
    <IconButton onClick={onClick}>
      {isVisible ? (
        <VisibilityOffOutlined style={{ color: '#D7DCE5' }} />
      ) : (
        <VisibilityOutlined style={{ color: '#D7DCE5' }} />
      )}
    </IconButton>
  );
}
